import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { CTSelectSetting, Option } from '../../../service/recordview-param';

@Component({
	selector: 'common-select-setting',
	templateUrl: './select-setting.component.html',
	styleUrls: ['./select-setting.component.scss']
})
export class SelectSettingComponent implements OnInit {
	@HostBinding('class.select-setting') hostClass = true;
	@Input() data: CTSelectSetting;
	constructor() {}
	ngOnInit() {
		this.data.Options = this.data.Options || [];
		if (this.data.Options.length === 0) {
			this.data.Options.push({ Text: 'æ°çéé¡¹', Value: 'val' } as Option);
		}
	}
	add(idx: number) {
		this.data.Options.splice(idx + 1, 0, { Text: 'æ°çéé¡¹', Value: 'val' } as Option);
	}
	remove(idx: number) {
		this.data.Options.splice(idx, 1);
	}
}
